module.exports = __webpack_public_path__ + "media/images/admin/icons/edit-16274f501fff452bf4410f97735d51d1.svg";